import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export type TPlanDetailsResponse = {
  productId: string;
  name: string;
  description: string;
  features: string[];
};

export function usePlanDetails({ id }: { id: string | null | undefined }) {
  const requestURL = id ? `billing-new/plan-features?id=${id}` : null;

  return useSWR<TPlanDetailsResponse>(
    requestURL,
    SWRFetcher({
      method: 'GET',
    })
  );
}
